<template>
  <div class="col-md-3 mb-sm-3 mb-md-0">
    <!-- <b-button
      variant="success"
      block
      size="lg"
      squared
      @click="redirectAtendimentos"
    >
      <i class="mdi mdi-database-cog-outline mdi-18px"></i>
      Serviços/Intervenções
    </b-button> -->

    <b-list-group role="tablist" class="shadow bg-white h-100 p-b rounded-0">
      <b-list-group-item
        @click="
          page = 'violacaodedireito';
          $emit('page', page);
        "
        :class="page == 'violacaodedireito' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Detalhes da Situação de VVD
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'atendimento';
          $emit('page', page);
        "
        :class="page == 'atendimento' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Atendimentos / Cronograma
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'encaminhamento';
          $emit('page', page);
        "
        :class="page == 'encaminhamento' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Encaminhamentos
      </b-list-group-item>
      <b-list-group-item
        @click="
          page = 'oficio';
          $emit('page', page);
        "
        :class="page == 'oficio' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Ofícios
      </b-list-group-item>

      <b-list-group-item
        @click="
          page = 'comentario';
          $emit('page', page);
        "
        :class="page == 'comentario' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Comentários
      </b-list-group-item>

      <b-list-group-item
        @click="
          page = 'notificacao';
          $emit('page', page);
        "
        :class="page == 'notificacao' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Notificações
      </b-list-group-item>
    </b-list-group>
  </div>
</template>
<script>
export default {
  props: ["active"],
  data() {
    return { page: "violacaodedireito" };
  },
  mounted() {
    if (this.active) {
      this.page = this.active;
    }
  },
  methods: {
    redirectAtendimentos() {
      this.$router.push({
        path: `/dashboard/violacaodedireitos/${this.$route.query.familia_id}`,
        query: { familia_id: this.$route.query.familia_id },
      });
    },
  },
};
</script>
